import React from 'react'

import { ConfirmationModal, ModalActionTypes } from '@acorns/web-components'
import { noop } from 'lodash'

import WarningIcon from 'assets/icons/exclamation-mark-gray-circle.svg'

type SessionAboutToExpireModal = {
  setShowSessionAboutToExpireModal: (value: boolean) => void
}

export function SessionAboutToExpireModal({
  setShowSessionAboutToExpireModal,
}: SessionAboutToExpireModal) {
  return (
    <ConfirmationModal
      isOpen={true}
      onRequestClose={noop}
      image={WarningIcon}
      title="Are You Still There?"
      message="You are about to be logged out due to inactivity."
      actions={[
        {
          type: ModalActionTypes.primary,
          label: 'I am still here',
          handler: () => {
            // Note: We just need to hide the modal here.
            // The SessionAutoRefresh component will take care of refreshing the session.
            setShowSessionAboutToExpireModal(false)
          },
        },
      ]}
    />
  )
}
